import { ConsentFormStatus } from "JS/Models/ConsentForm";
import Dexie, { Table } from "dexie";
import { Disclosure } from "JS/Models/Disclosure";

export interface VideoDexie {
    id: string;
    name: string;
    blob: Blob;
    skuId: string;
    description: string;
    release_date: string;
    isBundle?: boolean;
    disclosure?: Disclosure;
}
export interface AudioDexie {
    id: string;
    name: string;
    blob: Blob;
    skuId: string;
    description: string;
    release_date: string;
    isBundle?: boolean;
    media_title?: string;
    position?: number;
    no_of_files?: number;
    disclosure?: Disclosure;
}

export interface CourseDexie {
    id: string;
    courseNid: string;
    stepNid: string;
    blob: Blob;
}

export interface DocumentDexie {
    id: string;
    name: string;
    blob: Blob;
    description: string;
}
export interface ConsentFormDexie extends ConsentFormStatus {
    id: string;
}

export interface DisclosureDexie {
    id: string;
    blob: Blob;
}

class ContentDexie extends Dexie {
    // We just tell the typing system this is the case
    videos!: Table<VideoDexie>;
    audios!: Table<AudioDexie>;
    courses!: Table<CourseDexie>;
    documents!: Table<DocumentDexie>;
    consentForm!: Table<ConsentFormDexie>;
    disclosures!: Table<DisclosureDexie>;

    constructor() {
        super("Downloads");
        this.version(4).stores({
            videos: "id, name, blob, skuId, description, release_date",
            audios: "id, name, blob, skuId, description, release_date",
            courses: "id, courseNid, stepNid, blob",
            documents: "id, name, blob, description",
            consentForm:
                "id, ltdConsentStatus, redirectToAmwayConsentForm, ammwayConsentFormLink",
        });

        // never remove: a build declaring 4 cannot open a database already at 5, and every
        // download becomes unreadable. Keep this even if disclosures are stripped.
        this.version(5).stores({
            disclosures: "id",
        });
    }
}

let sharedDb: ContentDexie | null = null;

export function getDexieConnectionRefresh() {
    if (!sharedDb) sharedDb = new ContentDexie();
    if (!sharedDb.isOpen()) {
        const db = sharedDb;
        db.open().catch(function (err) {
            console.warn("IndexedDB open failed:", err);
            if (sharedDb === db) sharedDb = null;
        });
    }
    return sharedDb;
}

export function getDexieConnection() {
    return getDexieConnectionRefresh();
}
